import { forgetCreatedAssessment } from "@/lib/created-assessments"
import { MOCK_ASSESSMENTS } from "@/lib/mock/exam-data"

const deletedAssessmentIds = new Set<string>()

export function isAssessmentDeleted(assessmentId: string): boolean {
  return deletedAssessmentIds.has(assessmentId)
}

/** Demo delete — removes hub mock rows and hides course-scoped roster entries. */
export function deleteAssessment(assessmentId: string): boolean {
  const mockIndex = MOCK_ASSESSMENTS.findIndex(
    (row) => row.id === assessmentId || row.code === assessmentId,
  )
  if (mockIndex >= 0) {
    MOCK_ASSESSMENTS.splice(mockIndex, 1)
  }

  deletedAssessmentIds.add(assessmentId)
  forgetCreatedAssessment(assessmentId)
  return true
}
